export const redirect = [
  // { from: '^/myoldurl/(.*)$', to: '/comeallhere' }, // Many urls to one
  // { from: '^/anotherold/(.*)$', to: '/new/$1' } // One to one mapping

  {from: '^/catalog/opravy/f/pol=detskaya-1', to: '/catalog/opravy/f/pol=detskaya'},
  {from: '^/catalog/opravy/f/pol=detskaya-2', to: '/catalog/opravy/f/pol=detskaya'},

  {from: '^/catalog/opravy/f/pol=zhenskaya-1', to: '/catalog/opravy/f/pol=zhenskaya'},
  {from: '^/catalog/opravy/f/pol=zhenskaya-2', to: '/catalog/opravy/f/pol=zhenskaya'},

  {from: '^/catalog/opravy/f/pol=muzhskaya-1', to: '/catalog/opravy/f/pol=muzhskaya'},
  {from: '^/catalog/opravy/f/pol=muzhskaya-2', to: '/catalog/opravy/f/pol=muzhskaya'},

  {from: '^/catalog/opravy/f/pol=universalnaya-1', to: '/catalog/opravy/f/pol=universalnaya'},
  {from: '^/catalog/opravy/f/pol=universalnaya-2', to: '/catalog/opravy/f/pol=universalnaya'},

  {from: '^/opravy/la-stella/', to: '/catalog/opravy/f/brand=la-stella'},
  {from: '^/opravy/detskaya/', to: '/catalog/opravy/f/pol=detskaya'},
  {from: '^/opravy/fielmann/', to: '/catalog/opravy/f/brand=fielmann'},
  {from: '^/opravy/juniorlook/', to: '/catalog/opravy/f/brand=juniorlook'},
  {from: '^/opravy/muzhskaya/', to: '/catalog/opravy/f/pol=muzhskaya'},
  {from: '^/opravy/(.*)$', to: '/catalog/opravy'},

  {from: '^/aktsii/aktsii/kupi-linzy-acuvue-i-poluchi-multikartu-na-500-rubley/', to: '/aktsii/kupi-linzy-acuvue-i-poluchi-multikartu-na-500-rubley'},
  {from: '^/aktsii/aktsii/(.*)$', to: '/aktsii'},

  {from: '^/stat/ocki/(.*)$', to: "/stat/och/$1"},
  {from: '^/stat/ocki', to: "/stat/och"},

  {from: '^/discounts/', to: '/klientam/discounts'},
  {from: '^/c/proverka-zreniya-on-layn/', to: '/'},
  {from: '^/company/vrachi/', to: '/specialists'},

  {from: '^/acuvue/acuvue-oasys-for-astigmatism/', to: '/catalog/linzy/f/brand=acuvue/type=astigmaticheskie'},
  {from: '^/acuvue/acuvue-oasys-with-hydraclear-uv-12pk/', to: '/product/acuvue-oasys-with-hydraclear-uv-12pk'},

  {from: '^/linzy/acuvue/acuvue-oasys-with-hydraclear-uv-6pk/', to: '/product/acuvue-oasys-with-hydraclear-plus-107244-11'},
  {from: '^/linzy/acuvue/biolens-soft-toric-6pk/', to: '/product/biolens-soft-toric-6pk-114555-14'},
  {from: '^/linzy/na-mesyats/biolens/', to: '/catalog/linzy/f/period=do-1-mesyaca/brand=biolens'},
  {from: '^/linzy/na-mesyats/biofinity-multifocal/', to: '/product/biofinity-multifocal-3pk-090989-9'},
  {from: '^/linzy/odnodnevnye/1day-acuvue-oasys/', to: '/catalog/linzy/f/brand=acuvue/period=odnodnevnye'},
  {from: '^/linzy/odnodnevnye/dailies-total-1/', to: '/catalog/linzy/f/period=odnodnevnye/brand=dailies'},

  {from: '^/linzy/cvetnye-linzy/', to: '/catalog/linzy/f/type=cvetnye-linzy'},
  {from: '^/linzy/na-mesyats/', to: '/catalog/linzy/f/period=do-1-mesyaca'},
  {from: '^/linzy/odnodnevnye/', to: '/catalog/linzy/f/period=odnodnevnye'},

  {from: '^/promotions/aktsiya-skoro-v-shkolu-1508-309/', to: '/aktsii/15-na-zakaz-ochkov-detyam'},

  {from: '^/sertifikaty/', to: '/catalog/podarochnye-sertifikaty'},

  {from: '^/solntsezashitnye-ochki/gresso/', to: '/catalog/solncezashchitnye-ochki/f/brand=gresso'},
  {from: '^/solntsezashitnye-ochki/gucci-gg-0394s-001/', to: '/product/gucci-gg-0394s-001'},
  {from: '^/solntsezashitnye-ochki/muzhskaya-387/', to: '/catalog/solncezashchitnye-ochki/f/pol=muzhskaya'},
  {from: '^/solntsezashitnye-ochki/ray-ban/', to: '/catalog/solncezashchitnye-ochki/f/brand=ray-ban'},

  {from: '^/uslugi/detskiy-oftalmolog/', to: '/zapis/konsultaciya-detskogo-oftalmologa'},
  {from: '^/uslugi/ortokeratologiya/', to: '/stat/ortokeratologia/ortokeratologiya-ok-terapiya-horoshee-zrenie-bez-ochkov-linz-i-hirurgii'},


  {from: '^/salony-optiki/', to: '/kontakty'},
  {from: '^/remont-ochkov/', to: '/zapis'},
  {from: '^/uslugi/oftalmolog/', to: '/zapis/priem-oftalmologa-po-zabolevaniyam-glaz-bez'},
  {from: '^/uslugi/podbor-linz/', to: '/zapis/podbor-kontaktnyh-linz'},
  {from: '^/acuvue/', to: '/catalog/linzy/f/brand=acuvue'},

  {from: '^/linzy/(.*)$', to: '/catalog/linzy'},
  {from: '^/sredstva/(.*)$', to: '/catalog/aksessuary'},
  // {from: '^/uslugi/(.*)$', to: '/zapis'},
  {from: '^/solntsezashitnye-ochki/(.*)$', to: '/catalog/solncezashchitnye-ochki'},


  {from: '^/product/optima-fw-036549-9', to: '/product/optima-fw'},
  {from: '^/product/biolens-premium-3pk-091936-11', to: '/product/biolens-premium-3pk'},
  {from: '^/product/biofinity-109035-10', to: '/product/biofinity'},
  {from: '^/product/dailies-total-1-r8-5-30-pk-097951-11', to: '/product/dailies-total-1-r8-5-30-pk'},
  {from: '^/product/dailies-total-1-r8-5-90-pk-107213-11', to: '/product/dailies-total-1-r8-5-90-pk'},
  {from: '^/product/1day-acuvue-oasys-30-pk-107247-11', to: '/product/1day-acuvue-oasys-30-pk'},
  {from: '^/product/1day-acuvue-oasys-90-pk-107248-11', to: '/product/1day-acuvue-oasys-90-pk'},
  {from: '^/product/1day-acuvue-oasys-for-astigmatism-30-pk-110223-11', to: '/product/1day-acuvue-oasys-for-astigmatism-30-pk'},
  {from: '^/product/freshlook-colors-001559-9', to: '/product/freshlook-colors'},
  {from: '^/product/proclear-1day-30-pk-064035-11', to: '/product/proclear-1day-30-pk'},
  {from: '^/product/freshlook-dimensions-090982-10', to: '/product/freshlook-dimensions'},
  {from: '^/product/freshlook-dimensions-0000002606-9', to: '/product/freshlook-dimensions-0000002606'},
  {from: '^/product/clariti-1day-multifocal-30-pk-070637-11', to: '/product/clariti-1day-multifocal-30-pk'},
  {from: '^/product/biofinity-xr-3pk-091094-9', to: '/product/biofinity-xr-3pk'},
  {from: '^/product/biofinity-toric-3-pk-061151-10', to: '/product/biofinity-toric-3-pk'},
  {from: '^/product/biofinity-multifocal-3pk-090989-9', to: '/product/biofinity-multifocal-3pk'},
  {from: '^/product/air-optix-aqua-multifocal-028767-11', to: '/product/air-optix-aqua-multifocal'},
  {from: '^/product/air-optix-plus-hydraglyde-3pk-105382-11', to: '/product/air-optix-plus-hydraglyde-3pk'},
  {from: '^/product/air-optix-plus-hydraglyde-6pk-107618-11', to: '/product/air-optix-plus-hydraglyde-6pk'},
  {from: '^/product/air-optix-night-day-3-pk-035919-11', to: '/product/air-optix-night-day-3-pk'},
  {from: '^/product/adria-neon-037821-9', to: '/product/adria-neon'},
  {from: '^/product/adria-glamorous-037692-9', to: '/product/adria-glamorous'},
  {from: '^/product/adria-elegant-037680-9', to: '/product/adria-elegant'},
  {from: '^/product/adria-crazy-037868-9', to: '/product/adria-crazy'},
  {from: '^/product/pure-vision-2hd-114153-9', to: '/product/pure-vision-2hd'},
  {from: '^/product/biolens-toric-3pk-101703-9', to: '/product/biolens-toric-3pk'},
  {from: '^/product/biolens-1day-premium-30pk-101113-14', to: '/product/biolens-1day-premium-30pk'},
  {from: '^/product/avaira-vitality-6pk-114554-11', to: '/product/avaira-vitality-6pk'},
  {from: '^/product/air-optix-colors-094302-9', to: '/product/air-optix-colors'},
  {from: '^/product/ultra-3pk-0000010283-11', to: '/product/ultra-3pk'},
  {from: '^/product/freshlook-colorblends-032419-9', to: '/product/freshlook-colorblends'},
  {from: '^/product/1day-acuvue-trueye-r8-5-30-pk-031039-11', to: '/product/1day-acuvue-trueye-r8-5-30-pk'},
  {from: '^/product/1day-acuvue-trueye-r8-5-90-pk-036664-11', to: '/product/1day-acuvue-trueye-r8-5-90-pk'},
  {from: '^/product/acuvue-2-6pk-027391-11', to: '/product/acuvue-2-6pk'},
  {from: '^/product/misight-1day-30-pk-121807-11', to: '/product/misight-1day-30-pk'},
  {from: '^/product/dailies-aqua-comfort-plus-30pk-032336-11', to: '/product/dailies-aqua-comfort-plus-30pk'},
  {from: '^/product/clariti-1day-toric-30-pk-070636-11', to: '/product/clariti-1day-toric-30-pk'},
  {from: '^/product/clariti-1day-30-pk-0000013762-11', to: '/product/clariti-1day-30-pk'},
  {from: '^/product/biolens-soft-toric-6pk-114555-14', to: '/product/biolens-soft-toric-6pk'},
  {from: '^/product/biolens-soft-6pk-0000003860-14', to: '/product/biolens-soft-6pk'},
  {from: '^/product/biolens-1day-30-pk-068835-14', to: '/product/biolens-1day-30-pk'},
  {from: '^/product/biolens-premium-multifocal-3pk-114556-11', to: '/product/biolens-premium-multifocal-3pk'},
  {from: '^/product/avaira-vitality-toric-6pk-0000004340-11', to: '/product/avaira-vitality-toric-6pk'},
  {from: '^/product/air-optix-plus-hydraglyde-multifocal-119565-9', to: '/product/air-optix-plus-hydraglyde-multifocal'},
  {from: '^/product/air-optix-aqua-3pk-035788-11', to: '/product/air-optix-aqua-3pk'},
  {from: '^/product/air-optix-aqua-6-pk-064152-11', to: '/product/air-optix-aqua-6-pk'},
  {from: '^/product/bio-true-oneday-30-pk-037291-11', to: '/product/bio-true-oneday-30-pk'},
  {from: '^/product/soflens-daily-disposable-30pk-070905-14', to: '/product/soflens-daily-disposable-30pk'},
  {from: '^/product/soflens-daily-disposable-90-pk-032352-14', to: '/product/soflens-daily-disposable-90-pk'},
  {from: '^/product/adria-color-2-tone-037573-9', to: '/product/adria-color-2-tone'},
  {from: '^/product/1day-acuvue-moist-30-pk-001558-11', to: '/product/1day-acuvue-moist-30-pk'},
  {from: '^/product/1day-acuvue-moist-for-astigmatism-30-pk-031428-11', to: '/product/1day-acuvue-moist-for-astigmatism-30-pk'},
  {from: '^/product/1day-acuvue-moist-multifocal-30-pk-105443-11', to: '/product/1day-acuvue-moist-multifocal-30-pk'},
  {from: '^/product/proclear-029296-9', to: '/product/proclear'},
  {from: '^/product/myday-30pk-090988-11', to: '/product/myday'},
  {from: '^/product/air-optix-aqua-for-astigmatism-3-pk-028515-11', to: '/product/air-optix-aqua-for-astigmatism-3-pk'},
  {from: '^/product/acuvue-oasys-for-astigmatism-uv-027445-11', to: '/product/acuvue-oasys-for-astigmatism-uv'},
  {from: '^/product/acuvue-oasys-with-hydraclear-uv-24pk-107245-11', to: '/product/acuvue-oasys-with-hydraclear-uv-24pk'},
  {from: '^/product/acuvue-oasys-with-hydraclear-plus-107244-11', to: '/product/acuvue-oasys-with-hydraclear-plus'},
  {from: '^/product/podarochnyj-sertifikat-na-1000-rub-new', to: '/sertifikaty'},

  // Ссылки с верхним регистром преобразует в нижний
  // {
  //   from: '/(.*)[A-Z](.*)',
  //   to: (from: any, req: any) => {
  //     const base = req._parsedUrl.pathname.toLowerCase();
  //     const search = req._parsedUrl.search;
  //     return base + (search != null ? search : '');
  //   },
  // },


  {
    // eslint-disable-next-line
    from: '(?!^\/$|^\/[?].*$)(.*\/[?](.*)$|.*\/$)',
    to: (from : any, req : any) => {
      const base = req._parsedUrl.pathname.replace(/\/$/, '');
      const search = req._parsedUrl.search;
      return base + (search != null ? search : '');
    }
  }
];



